import uniqueId from 'lodash/uniqueId';
import React, { useState } from 'react';
import { TextArea } from 'ui';

type CharacterLimitTextAreaProps = React.ComponentProps<typeof TextArea> & {
  limitMessage?: string;
};

const CharacterLimitTextArea = React.forwardRef<HTMLTextAreaElement, CharacterLimitTextAreaProps>(
  ({ 'aria-describedby': ariaDescribedBy, limitMessage = '', ...props }, ref): JSX.Element => {
    const [noticeId] = useState<string>(() => uniqueId('character-limit-'));
    // FormField sobrescribe el aria-describedby del hijo: aquí se recibe su valor y se le suma el aviso.
    const describedBy = [ariaDescribedBy, limitMessage ? noticeId : null].filter(Boolean).join(' ') || undefined;

    return (
      <>
        <TextArea {...props} aria-describedby={describedBy} ref={ref} />
        {/* Siempre montada: una región viva que nace ya con texto no se anuncia de forma fiable. */}
        <output aria-live="polite" className={limitMessage ? 'message-sender__character-limit' : undefined} id={noticeId}>
          {limitMessage && <span className="message-sender__character-limit-text">{limitMessage}</span>}
        </output>
      </>
    );
  }
);

CharacterLimitTextArea.displayName = 'CharacterLimitTextArea';

export default CharacterLimitTextArea;
